import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { enums } from "../lib";

/**
 * Use Group Id Hook
 */
export default (exclusionReasonId) => {
    const { exclusionReasonTypes } = useSelector((state) => state.typesList);
    const { assetIsSold, assetDeliveredToCustomerAndNotPaid } =
        enums.status.exclusionReason;

    const isExclusionDatePicker = useMemo(() => {
        const isExclusionDate = [
            assetIsSold,
            assetDeliveredToCustomerAndNotPaid
        ];
        if (exclusionReasonTypes && exclusionReasonId) {
            return isExclusionDate.includes(parseInt(exclusionReasonId));
        } else return false;
    }, [exclusionReasonId, exclusionReasonTypes]);

    return isExclusionDatePicker;
};
